import { ClientSettingTypeEnum } from '@/dto';
import {
    ISaveSettingsRequestModel,
} from '../settingsChangeServiceContract';
import { ChangedSetting } from './';

export class SaveSettingsRequestModel implements ISaveSettingsRequestModel {
    public changes: ChangedSetting[];
    public forDeleteGlobals: string[];
    public settingType: ClientSettingTypeEnum;
    public indicators: string[];
    public userId?: string;
    public roleName?: string;
    public forDeleteTableLayouts: string[];

    constructor() {
        this.changes = [];
        this.forDeleteGlobals = [];
        this.settingType = ClientSettingTypeEnum.Default;
        this.indicators = [];
        this.forDeleteTableLayouts = [];
    }
}
